import Vue from 'vue';
import {
  ADD_ALL_CLIENT_BRANDS_REQUEST,
  ADD_ALL_CLIENT_BRANDS_SUCCESS,
  ADD_ALL_CLIENT_BRANDS_ERROR,
  GET_BRANDS_REQUEST,
  GET_BRANDS_SUCCESS,
  GET_BRANDS_ERROR,
  GET_ALL_CLIENT_BRANDS_REQUEST,
  GET_ALL_CLIENT_BRANDS_SUCCESS,
  GET_ALL_CLIENT_BRANDS_ERROR,
  GET_CLIENT_BRAND_WITH_WINES_REQUEST,
  GET_CLIENT_BRAND_WITH_WINES_SUCCESS,
  GET_CLIENT_BRAND_WITH_WINES_ERROR,
  GET_RIVAL_BRAND_WITH_WINES_REQUEST,
  GET_RIVAL_BRAND_WITH_WINES_SUCCESS,
  GET_RIVAL_BRAND_WITH_WINES_ERROR,
  UPDATE_CLIENT_BRAND_REQUEST,
  UPDATE_CLIENT_BRAND_SUCCESS,
  UPDATE_CLIENT_BRAND_ERROR,
  UPDATE_RIVAL_BRAND_REQUEST,
  UPDATE_RIVAL_BRAND_SUCCESS,
  UPDATE_RIVAL_BRAND_ERROR
} from './actionTypes';
import brandApi from '../../_api/brand';

const state = {
  brands: {},
  cbrands: {},
  status: '',
  errors: [],
  hasLoadedOnce: false
};

const getters = {
  brands: (state) => state.brands
};

const actions = {
  [ADD_ALL_CLIENT_BRANDS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADD_ALL_CLIENT_BRANDS_REQUEST);
      brandApi
        .addAllClientBrands(payload)
        .then((response) => {
          commit(ADD_ALL_CLIENT_BRANDS_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(ADD_ALL_CLIENT_BRANDS_ERROR, error);
          reject(error);
        });
    });
  },

  [GET_BRANDS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_BRANDS_REQUEST);
      brandApi
        .getBrands(payload)
        .then((response) => {
          commit(GET_BRANDS_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_BRANDS_ERROR, error);
          reject(error);
        });
    });
  },
  [GET_ALL_CLIENT_BRANDS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_ALL_CLIENT_BRANDS_REQUEST);
      brandApi
        .getAllClientBrands(payload)
        .then((response) => {
          commit(GET_ALL_CLIENT_BRANDS_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_ALL_CLIENT_BRANDS_ERROR);
          reject(error);
        });
    });
  },
  [GET_CLIENT_BRAND_WITH_WINES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_CLIENT_BRAND_WITH_WINES_REQUEST);

      brandApi
        .getClientBrandWithWines(payload)
        .then((response) => {
          commit(GET_CLIENT_BRAND_WITH_WINES_SUCCESS, response);
          resolve(response.data);
        })
        .catch((error) => {
          commit(GET_CLIENT_BRAND_WITH_WINES_ERROR, error);
          reject(error);
        });
    });
  },
  [GET_RIVAL_BRAND_WITH_WINES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_RIVAL_BRAND_WITH_WINES_REQUEST);

      brandApi
        .getRivalBrandWithWines(payload)
        .then((response) => {
          commit(GET_RIVAL_BRAND_WITH_WINES_SUCCESS, response);
          resolve(response.data);
        })
        .catch((error) => {
          commit(GET_RIVAL_BRAND_WITH_WINES_ERROR, error);
          reject(error);
        });
    });
  },

  [UPDATE_CLIENT_BRAND_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(UPDATE_CLIENT_BRAND_REQUEST);

      brandApi
        .updateClientBrand(payload)
        .then((response) => {
          commit(UPDATE_CLIENT_BRAND_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(UPDATE_CLIENT_BRAND_ERROR, error);
          reject(error);
        });
    });
  },
  [UPDATE_RIVAL_BRAND_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(UPDATE_RIVAL_BRAND_REQUEST);

      brandApi
        .updateRivalBrand(payload)
        .then((response) => {
          commit(UPDATE_RIVAL_BRAND_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(UPDATE_RIVAL_BRAND_ERROR, error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [ADD_ALL_CLIENT_BRANDS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADD_ALL_CLIENT_BRANDS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'cbrands', response.data.results);
  },
  [ADD_ALL_CLIENT_BRANDS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_BRANDS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_BRANDS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'brands', response.data.results);
  },
  [GET_BRANDS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_ALL_CLIENT_BRANDS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_ALL_CLIENT_BRANDS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'cbrands', response.data.results);
  },
  [GET_ALL_CLIENT_BRANDS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_CLIENT_BRAND_WITH_WINES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_CLIENT_BRAND_WITH_WINES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'client_brands_with_wines', response.data);
  },
  [GET_CLIENT_BRAND_WITH_WINES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_RIVAL_BRAND_WITH_WINES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_RIVAL_BRAND_WITH_WINES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'rival_brands_with_wines', response.data);
  },
  [GET_RIVAL_BRAND_WITH_WINES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [UPDATE_CLIENT_BRAND_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [UPDATE_CLIENT_BRAND_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'brands', response.data.results);
  },
  [UPDATE_CLIENT_BRAND_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [UPDATE_RIVAL_BRAND_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [UPDATE_RIVAL_BRAND_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'brands', response.data.results);
  },
  [UPDATE_RIVAL_BRAND_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
